import { makeChartComp } from '../../../util/makeChartComp';
var TinyProgressChart = makeChartComp('TinyProgress');
export default TinyProgressChart;
